import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f35953a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  style: {"overflow-y":"scroll"},
  class: "d-block show modal fade beneficiary_details",
  id: "beneficiary_details",
  role: "dialog"
}
const _hoisted_2 = {
  class: "modal-dialog modal-lg",
  role: "document"
}
const _hoisted_3 = { class: "modal-content bg-light" }
const _hoisted_4 = { class: "modal-header pb-0" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { id: "doc_title" }, "Beneficiary Details", -1))
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = {
  class: "tab-content",
  id: "nav-tabContent"
}
const _hoisted_8 = { class: "row my-3 justify-content-center" }
const _hoisted_9 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2" }
const _hoisted_10 = { class: "login-card" }
const _hoisted_11 = { class: "login-body personal" }
const _hoisted_12 = { class: "row mt-3" }
const _hoisted_13 = { class: "col-md-12 col-12" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Corporate or Individual", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select type", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "corporate" }, "Corporate", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "individual" }, "Individual", -1))
const _hoisted_19 = {
  key: 0,
  class: "col-md-12 col-12"
}
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name of beneficiary", -1))
const _hoisted_22 = {
  key: 1,
  class: "col-md-12 col-12"
}
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Company registration number of beneficiary", -1))
const _hoisted_25 = {
  key: 2,
  class: "col-md-12 col-12"
}
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Country of residency of Beneficiary", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Country", -1))
const _hoisted_29 = ["value"]
const _hoisted_30 = {
  key: 3,
  class: "col-md-12 col-12"
}
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Country of registration of Beneficiary", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select your country", -1))
const _hoisted_34 = ["value"]
const _hoisted_35 = {
  key: 4,
  class: "col-md-12 col-12"
}
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Structure of Beneficiary", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "public" }, "Public", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "private" }, "Private", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "partnership" }, "Partnership", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "individual" }, "Individual", -1))
const _hoisted_43 = {
  key: 5,
  class: "col-md-12 col-12"
}
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name of person making payment", -1))
const _hoisted_46 = { class: "col-md-12 col-12" }
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Passport number of beneficiary", -1))
const _hoisted_49 = { class: "col-md-12 col-12" }
const _hoisted_50 = { class: "form-group" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Passport expiry of beneficiary", -1))
const _hoisted_52 = { class: "col-md-12 col-12" }
const _hoisted_53 = { class: "form-group" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Country of of issue of passport of beneficiary", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select your country", -1))
const _hoisted_56 = ["value"]
const _hoisted_57 = { class: "col-md-12 col-12" }
const _hoisted_58 = { class: "form-group" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Date of Birth of Beneficiary", -1))
const _hoisted_60 = { class: "col-md-12 col-12" }
const _hoisted_61 = { class: "form-group" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Home address of Beneficiary", -1))
const _hoisted_63 = { class: "form-group place_suggest d-none" }
const _hoisted_64 = {
  class: "card place_suggest",
  style: {"max-width":"100%","overflow-y":"scroll","max-height":"250px"}
}
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["id"]
const _hoisted_67 = { style: {"font-weight":"600","cursor":"pointer"} }
const _hoisted_68 = {
  class: "p-0 m-0",
  style: {"color":"grey","cursor":"pointer"}
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "m-0" }, null, -1))
const _hoisted_70 = { class: "col-md-12 col-12" }
const _hoisted_71 = { class: "form-group" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Email address of Beneficiary", -1))
const _hoisted_73 = { class: "col-md-12 col-12" }
const _hoisted_74 = { class: "form-group" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Mobile/Cell Number of Beneficiary", -1))
const _hoisted_76 = { class: "col-md-12 col-12" }
const _hoisted_77 = { class: "form-group" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name of bank", -1))
const _hoisted_79 = { class: "col-md-12 col-12" }
const _hoisted_80 = { class: "form-group" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Address of bank", -1))
const _hoisted_82 = { class: "col-md-12 col-12" }
const _hoisted_83 = { class: "form-group" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Bank SWIFT code", -1))
const _hoisted_85 = { class: "col-md-12 col-12" }
const _hoisted_86 = { class: "form-group" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Bank account name", -1))
const _hoisted_88 = { class: "col-md-12 col-12" }
const _hoisted_89 = { class: "form-group" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Bank account number", -1))
const _hoisted_91 = { class: "col-md-12 col-12" }
const _hoisted_92 = { class: "form-group" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Beneficiary reference number", -1))
const _hoisted_94 = { class: "col-md-12 col-12" }
const _hoisted_95 = { class: "form-group" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Your reference number", -1))
const _hoisted_97 = { class: "col-md-12 col-12" }
const _hoisted_98 = { class: "form-group" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Transmission Type", -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select type", -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "swift_mt103" }, "SWIFT MT103", -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "rtgs" }, "RTGS", -1))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "swift_gpi" }, "SWIFT GPI", -1))
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "bank_draft" }, "Bank Draft", -1))
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "sblc_bg" }, "SBLC/BG", -1))
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "dlc" }, "DLC", -1))
const _hoisted_107 = { class: "col-md-12 col-12" }
const _hoisted_108 = { class: "form-group" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Bank officer name", -1))
const _hoisted_110 = { class: "col-md-12 col-12" }
const _hoisted_111 = { class: "form-group" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Bank officer phone number", -1))
const _hoisted_113 = { class: "col-md-12 col-12" }
const _hoisted_114 = { class: "form-group" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Bank officer email address", -1))
const _hoisted_116 = { class: "col-md-12 col-12" }
const _hoisted_117 = { class: "form-group" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Is the Beneficiary a trust ?", -1))
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "beneficiary_trust0"
}, " Yes ", -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "beneficiary_trust1"
}, " No ", -1))
const _hoisted_122 = {
  key: 6,
  class: "col-md-12 col-12"
}
const _hoisted_123 = { class: "form-group" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Upload trust deed", -1))
const _hoisted_125 = ["src"]
const _hoisted_126 = ["innerHTML"]
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_128 = { style: {"margin-left":"10px"} }
const _hoisted_129 = { class: "col-md-12 col-12" }
const _hoisted_130 = { class: "form-group" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Is the Beneficiary a USA citizen ?", -1))
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "usa_citizen0"
}, " Yes ", -1))
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "usa_citizen1"
}, " No ", -1))
const _hoisted_135 = {
  key: 7,
  class: "col-md-12 col-12"
}
const _hoisted_136 = { class: "form-group" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "If USA citizen or tax resident of USA is marked Yes, kindly provide social security number of Beneficiary", -1))
const _hoisted_138 = { class: "col-md-12 col-12" }
const _hoisted_139 = { class: "form-group" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Is the Beneficiary a tax resident of the USA ?", -1))
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "beneficiary_tax_resident_usa0"
}, " Yes ", -1))
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "beneficiary_tax_resident_usa1"
}, " No ", -1))
const _hoisted_144 = {
  key: 8,
  class: "col-12"
}
const _hoisted_145 = { class: "form-group" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Beneficiary Tax ID", -1))
const _hoisted_147 = {
  key: 9,
  class: "col-md-12 col-12"
}
const _hoisted_148 = { class: "form-group" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Certified Copy Colour Passport of Beneficiary (Included) ?", -1))
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "colorPass0"
}, " Yes ", -1))
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "colorPass1"
}, " No ", -1))
const _hoisted_153 = {
  key: 0,
  class: "form-group"
}
const _hoisted_154 = ["innerHTML"]
const _hoisted_155 = {
  key: 3,
  class: "progress"
}
const _hoisted_156 = ["aria-valuenow"]
const _hoisted_157 = { class: "col-md-12 col-12" }
const _hoisted_158 = { class: "form-group" }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Certified Copy Utility Bill Showing Proof of Residential Address of Beneficiary (Included?)", -1))
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "resiProof0"
}, " Yes ", -1))
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "resiProof1"
}, " No ", -1))
const _hoisted_163 = {
  key: 0,
  class: "form-group"
}
const _hoisted_164 = ["innerHTML"]
const _hoisted_165 = {
  key: 3,
  class: "progress"
}
const _hoisted_166 = ["aria-valuenow"]
const _hoisted_167 = { class: "col-md-12 col-12" }
const _hoisted_168 = { class: "form-group" }
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Copy of contract or invoice between Caprock Account Holder and Beneficiary as proof of transaction (Included) ?", -1))
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "contract_proof0"
}, " Yes ", -1))
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "contract_proof1"
}, " No ", -1))
const _hoisted_173 = {
  key: 0,
  class: "form-group"
}
const _hoisted_174 = ["innerHTML"]
const _hoisted_175 = {
  key: 3,
  class: "progress"
}
const _hoisted_176 = ["aria-valuenow"]
const _hoisted_177 = {
  key: 10,
  class: "col-md-12 col-12"
}
const _hoisted_178 = { class: "form-group" }
const _hoisted_179 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Certified Certificate of Incorporation from Beneficiary (Included) ?", -1))
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "incorporation_certi0"
}, " Yes ", -1))
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "incorporation_certi1"
}, " No ", -1))
const _hoisted_183 = {
  key: 0,
  class: "form-group"
}
const _hoisted_184 = ["innerHTML"]
const _hoisted_185 = {
  key: 3,
  class: "progress"
}
const _hoisted_186 = ["aria-valuenow"]
const _hoisted_187 = {
  key: 11,
  class: "col-md-12 col-12"
}
const _hoisted_188 = { class: "form-group" }
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Certified Copy of Drivers License of Beneficiary (Included) ?", -1))
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "driver_license0"
}, " Yes ", -1))
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "p-cursor",
  for: "driver_license1"
}, " No ", -1))
const _hoisted_193 = {
  key: 0,
  class: "form-group"
}
const _hoisted_194 = ["innerHTML"]
const _hoisted_195 = {
  key: 3,
  class: "progress"
}
const _hoisted_196 = ["aria-valuenow"]
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row justify-content-end mx-md-0 mx-1 mb-5" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-3 px-1" }, [
      /*#__PURE__*/_createElementVNode("button", {
        type: "submit",
        class: "subBtn btn btn-outline-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
      }, " Update ")
    ])
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.load_on==1)
      ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.beneficiary_on==1 && typeof _ctx.beneficiary_id!='undefined' &&  _ctx.beneficiary_id!=null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("span", {
                  class: "p-cursor miral_close_icon",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('beneficiary_details')))
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_Form, {
                    method: "POST",
                    action: "/",
                    class: "my-1 card p-2",
                    onSubmit: _ctx.updateBeneficiary
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("div", _hoisted_14, [
                                    _hoisted_15,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.bform.beneficiary_type,
                                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bform.beneficiary_type) = $event)),
                                      class: "form-control",
                                      name: "beneficiary_type",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_16,
                                        _hoisted_17,
                                        _hoisted_18
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_type"
                                    })
                                  ])
                                ]),
                                (_ctx.bform.beneficiary_type=='corporate')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      _createElementVNode("div", _hoisted_20, [
                                        _hoisted_21,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.bform.beneficiary_name,
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.bform.beneficiary_name) = $event)),
                                          placeholder: "i.e. Jonaten ",
                                          class: "form-control selected-field",
                                          name: "beneficiary_name",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_name"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.bform.beneficiary_type=='corporate')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                      _createElementVNode("div", _hoisted_23, [
                                        _hoisted_24,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.bform.beneficiary_company_reg_no,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bform.beneficiary_company_reg_no) = $event)),
                                          placeholder: "i.e. IT56789 ",
                                          class: "form-control selected-field",
                                          name: "beneficiary_company_reg_no",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_company_reg_no"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.bform.beneficiary_type=='corporate')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                      _createElementVNode("div", _hoisted_26, [
                                        _hoisted_27,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.bform.beneficiary_nationality,
                                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.bform.beneficiary_nationality) = $event)),
                                          class: "form-control",
                                          name: "beneficiary_nationality",
                                          as: "select",
                                          rules: _ctx.selectField
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_28,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: country.country_id,
                                                value: country.country_id
                                              }, _toDisplayString(country.country_name), 9, _hoisted_29))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_nationality"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.bform.beneficiary_type=='corporate')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                      _createElementVNode("div", _hoisted_31, [
                                        _hoisted_32,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.bform.beneficiary_reg_country,
                                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.bform.beneficiary_reg_country) = $event)),
                                          class: "form-control",
                                          name: "beneficiary_reg_country",
                                          as: "select",
                                          rules: _ctx.selectField
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_33,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: country.country_id,
                                                value: country.country_id
                                              }, _toDisplayString(country.country_name), 9, _hoisted_34))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_reg_country"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.bform.beneficiary_structure!='')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                      _createElementVNode("div", _hoisted_36, [
                                        _hoisted_37,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.bform.beneficiary_structure,
                                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bform.beneficiary_structure) = $event)),
                                          class: "form-control",
                                          name: "beneficiary_structure",
                                          as: "select",
                                          rules: _ctx.selectField
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_38,
                                            _hoisted_39,
                                            _hoisted_40,
                                            _hoisted_41,
                                            _hoisted_42
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_structure"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.bform.beneficiary_type=='individual')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                      _createElementVNode("div", _hoisted_44, [
                                        _hoisted_45,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.bform.beneficiary_name,
                                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.bform.beneficiary_name) = $event)),
                                          placeholder: "i.e. Jonaten ",
                                          class: "form-control selected-field",
                                          name: "beneficiary_name",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_name"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_46, [
                                  _createElementVNode("div", _hoisted_47, [
                                    _hoisted_48,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.bform.beneficiary_passport_no,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.bform.beneficiary_passport_no) = $event)),
                                      placeholder: "i.e. L8989S446546 ",
                                      class: "form-control selected-field",
                                      name: "beneficiary_passport_no",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_passport_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_49, [
                                  _createElementVNode("div", _hoisted_50, [
                                    _hoisted_51,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.bform.beneficiary_passport_expiry,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.bform.beneficiary_passport_expiry) = $event)),
                                      class: "form-control selected-field",
                                      name: "beneficiary_passport_expiry",
                                      type: "date",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_passport_expiry"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_52, [
                                  _createElementVNode("div", _hoisted_53, [
                                    _hoisted_54,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.bform.beneficiary_passport_country,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.bform.beneficiary_passport_country) = $event)),
                                      class: "form-control",
                                      name: "beneficiary_passport_country",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_55,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countries, (country) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: country.country_id,
                                            value: country.country_id
                                          }, _toDisplayString(country.country_name), 9, _hoisted_56))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_passport_country"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_57, [
                                  _createElementVNode("div", _hoisted_58, [
                                    _hoisted_59,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.bform.beneficiary_dob,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.bform.beneficiary_dob) = $event)),
                                      class: "form-control selected-field",
                                      name: "beneficiary_dob",
                                      type: "date",
                                      rules: _ctx.requiredField,
                                      onclick: "this.type='date'",
                                      onfocus: "this.type='date';",
                                      onblur: "(typeof this.value!='undefined' && this.value!='' && this.value!=null) ? this.type='date' : this.type='text'",
                                      placeholder: "D.O.B"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_dob"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_60, [
                                  _createElementVNode("div", _hoisted_61, [
                                    _hoisted_62,
                                    _createVNode(_component_Field, {
                                      onKeyup: _cache[12] || (_cache[12] = ($event: any) => {_ctx.textSearch($event);}),
                                      onfocus: "this.setAttribute('autocomplete', 'disable-autocomplete');",
                                      autocomplete: "off",
                                      modelValue: _ctx.bform.beneficiary_home_address,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.bform.beneficiary_home_address) = $event)),
                                      class: "form-control selected-field",
                                      name: "beneficiary_home_address",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_home_address"
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_63, [
                                    _createElementVNode("div", _hoisted_64, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.place_list, (item) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: item.id,
                                          onClick: ($event: any) => {_ctx.set_address(item.id);},
                                          class: "suggestDiv"
                                        }, [
                                          _createElementVNode("div", {
                                            class: "d-none",
                                            id: 'addr_'+item.id
                                          }, _toDisplayString(item.address), 9, _hoisted_66),
                                          _createElementVNode("h6", _hoisted_67, _toDisplayString(item.title), 1),
                                          _createElementVNode("p", _hoisted_68, _toDisplayString(item.details), 1)
                                        ], 8, _hoisted_65))
                                      }), 128)),
                                      _hoisted_69
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_70, [
                                  _createElementVNode("div", _hoisted_71, [
                                    _hoisted_72,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.bform.beneficiary_email_id,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.bform.beneficiary_email_id) = $event)),
                                      class: "form-control selected-field",
                                      name: "beneficiary_email_id",
                                      type: "text",
                                      rules: [_ctx.requiredField,_ctx.validateEmail]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_email_id"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_73, [
                                  _createElementVNode("div", _hoisted_74, [
                                    _hoisted_75,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.bform.beneficiary_phone_no,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.bform.beneficiary_phone_no) = $event)),
                                      class: "form-control selected-field",
                                      name: "beneficiary_phone_no",
                                      type: "text",
                                      rules: [_ctx.requiredField,_ctx.mobileField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_phone_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_76, [
                                  _createElementVNode("div", _hoisted_77, [
                                    _hoisted_78,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.bform.beneficiary_bank_name,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.bform.beneficiary_bank_name) = $event)),
                                      placeholder: "i.e. CITI Bank ",
                                      class: "form-control selected-field",
                                      name: "beneficiary_bank_name",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_bank_name"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_79, [
                                  _createElementVNode("div", _hoisted_80, [
                                    _hoisted_81,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.bform.beneficiary_bank_address,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.bform.beneficiary_bank_address) = $event)),
                                      placeholder: "i.e. Sea Link,  Sydney",
                                      class: "form-control selected-field",
                                      name: "beneficiary_bank_address",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_bank_address"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_82, [
                                  _createElementVNode("div", _hoisted_83, [
                                    _hoisted_84,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.bform.beneficiary_bank_swift_code,
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.bform.beneficiary_bank_swift_code) = $event)),
                                      placeholder: "i.e. JJDH546",
                                      class: "form-control selected-field",
                                      name: "beneficiary_bank_swift_code",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_bank_swift_code"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_85, [
                                  _createElementVNode("div", _hoisted_86, [
                                    _hoisted_87,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.bform.beneficiary_bank_ac_name,
                                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.bform.beneficiary_bank_ac_name) = $event)),
                                      placeholder: "i.e. Jonaten ",
                                      class: "form-control selected-field",
                                      name: "beneficiary_bank_ac_name",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_bank_ac_name"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_88, [
                                  _createElementVNode("div", _hoisted_89, [
                                    _hoisted_90,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.bform.beneficiary_bank_ac_no,
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.bform.beneficiary_bank_ac_no) = $event)),
                                      placeholder: "i.e. 3539 000556  ",
                                      class: "form-control selected-field",
                                      name: "beneficiary_bank_ac_no",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_bank_ac_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_91, [
                                  _createElementVNode("div", _hoisted_92, [
                                    _hoisted_93,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.bform.beneficiary_ref_no,
                                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.bform.beneficiary_ref_no) = $event)),
                                      placeholder: "i.e. IG987982  ",
                                      class: "form-control selected-field",
                                      name: "beneficiary_ref_no",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_ref_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_94, [
                                  _createElementVNode("div", _hoisted_95, [
                                    _hoisted_96,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.bform.beneficiary_your_ref_no,
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.bform.beneficiary_your_ref_no) = $event)),
                                      placeholder: "i.e. IG987982  ",
                                      class: "form-control selected-field",
                                      name: "beneficiary_your_ref_no",
                                      type: "text",
                                      rules: _ctx.requiredField
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_your_ref_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_97, [
                                  _createElementVNode("div", _hoisted_98, [
                                    _hoisted_99,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.bform.beneficiary_payment_transmission_type,
                                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.bform.beneficiary_payment_transmission_type) = $event)),
                                      class: "form-control",
                                      name: "beneficiary_payment_transmission_type",
                                      as: "select",
                                      rules: _ctx.selectField
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_100,
                                        _hoisted_101,
                                        _hoisted_102,
                                        _hoisted_103,
                                        _hoisted_104,
                                        _hoisted_105,
                                        _hoisted_106
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_payment_transmission_type"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_107, [
                                  _createElementVNode("div", _hoisted_108, [
                                    _hoisted_109,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.bform.beneficiary_bank_officer_name,
                                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.bform.beneficiary_bank_officer_name) = $event)),
                                      placeholder: "i.e. Officer name",
                                      class: "form-control selected-field",
                                      name: "beneficiary_bank_officer_name",
                                      type: "text"
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_bank_officer_name"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_110, [
                                  _createElementVNode("div", _hoisted_111, [
                                    _hoisted_112,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.bform.beneficiary_bank_officer_phone_no,
                                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.bform.beneficiary_bank_officer_phone_no) = $event)),
                                      placeholder: "i.e. +4 455545665  ",
                                      class: "form-control selected-field",
                                      name: "beneficiary_bank_officer_phone_no",
                                      type: "text",
                                      rules: [_ctx.mobileField]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_bank_officer_phone_no"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_113, [
                                  _createElementVNode("div", _hoisted_114, [
                                    _hoisted_115,
                                    _createVNode(_component_Field, {
                                      modelValue: _ctx.bform.beneficiary_bank_officer_email_address,
                                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.bform.beneficiary_bank_officer_email_address) = $event)),
                                      placeholder: "i.e. email@address.com  ",
                                      class: "form-control selected-field",
                                      name: "beneficiary_bank_officer_email_address",
                                      type: "text",
                                      rules: [_ctx.validateEmail]
                                    }, null, 8, ["modelValue", "rules"]),
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_bank_officer_email_address"
                                    })
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_116, [
                                  _createElementVNode("div", _hoisted_117, [
                                    _hoisted_118,
                                    _createTextVNode(),
                                    _hoisted_119,
                                    _createVNode(_component_Field, {
                                      id: "beneficiary_trust0",
                                      modelValue: _ctx.bform.beneficiary_trust,
                                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.bform.beneficiary_trust) = $event)),
                                      class: "mx-2",
                                      name: "beneficiary_trust",
                                      type: "radio",
                                      rules: _ctx.requiredField,
                                      value: "1"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _hoisted_120,
                                    _createVNode(_component_Field, {
                                      id: "beneficiary_trust1",
                                      modelValue: _ctx.bform.beneficiary_trust,
                                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.bform.beneficiary_trust) = $event)),
                                      class: "ml-4 mx-2",
                                      name: "beneficiary_trust",
                                      type: "radio",
                                      rules: _ctx.requiredField,
                                      value: "0"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _hoisted_121,
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_trust"
                                    })
                                  ])
                                ]),
                                (_ctx.bform.beneficiary_trust==1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                                      _createElementVNode("div", _hoisted_123, [
                                        _hoisted_124,
                                        (typeof _ctx.bform.trust_deed_url!='undefined' && _ctx.bform.trust_deed_url!='')
                                          ? (_openBlock(), _createBlock(_component_Field, {
                                              key: 0,
                                              onChange: _cache[29] || (_cache[29] = ($event: any) => {_ctx.fetch_file_bf($event);_ctx.onFileChange_bf($event);}),
                                              class: "form-control selected-field",
                                              name: "trust_deed",
                                              type: "file"
                                            }))
                                          : _createCommentVNode("", true),
                                        (typeof _ctx.bform.trust_deed_url=='undefined' || _ctx.bform.trust_deed_url=='')
                                          ? (_openBlock(), _createBlock(_component_Field, {
                                              key: 1,
                                              onChange: _cache[30] || (_cache[30] = ($event: any) => {_ctx.fetch_file_bf($event);_ctx.onFileChange_bf($event);}),
                                              class: "form-control selected-field",
                                              name: "trust_deed",
                                              type: "file",
                                              rules: _ctx.requiredField
                                            }, null, 8, ["rules"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "trust_deed"
                                        }),
                                        _createElementVNode("img", {
                                          class: "p-cursor",
                                          src: _ctx.s2_image_url,
                                          onClick: _cache[31] || (_cache[31] = ($event: any) => {_ctx.openDoc(_ctx.s2_image_url);}),
                                          onError: _cache[32] || (_cache[32] = 
//@ts-ignore
(...args) => (_ctx.s2LoadError && _ctx.s2LoadError(...args))),
                                          style: {"height":"auto","width":"200px"}
                                        }, null, 40, _hoisted_125),
                                        (_ctx.s2_image_url=='' || _ctx.s2_not_image==1)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 2,
                                              class: "p-cursor",
                                              onClick: _cache[33] || (_cache[33] = ($event: any) => {_ctx.openDoc(_ctx.s2_doc_url);})
                                            }, [
                                              _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_126),
                                              _hoisted_127,
                                              _createElementVNode("p", _hoisted_128, _toDisplayString(_ctx.file_s2_name), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_129, [
                                  _createElementVNode("div", _hoisted_130, [
                                    _hoisted_131,
                                    _createTextVNode(),
                                    _hoisted_132,
                                    _createVNode(_component_Field, {
                                      id: "usa_citizen0",
                                      modelValue: _ctx.bform.beneficiary_usa_citizen,
                                      "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.bform.beneficiary_usa_citizen) = $event)),
                                      class: "mx-2",
                                      name: "beneficiary_usa_citizen",
                                      type: "radio",
                                      rules: _ctx.requiredField,
                                      value: "1"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _hoisted_133,
                                    _createVNode(_component_Field, {
                                      id: "usa_citizen1",
                                      modelValue: _ctx.bform.beneficiary_usa_citizen,
                                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.bform.beneficiary_usa_citizen) = $event)),
                                      class: "ml-4 mx-2",
                                      name: "beneficiary_usa_citizen",
                                      type: "radio",
                                      rules: _ctx.requiredField,
                                      value: "0"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _hoisted_134,
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_usa_citizen"
                                    })
                                  ])
                                ]),
                                (_ctx.bform.beneficiary_type=='new' && (_ctx.bform.beneficiary_usa_citizen==1 || _ctx.bform.beneficiary_tax_resident_usa==1))
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                                      _createElementVNode("div", _hoisted_136, [
                                        _hoisted_137,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.bform.beneficiary_social_security_no,
                                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.bform.beneficiary_social_security_no) = $event)),
                                          class: "form-control selected-field",
                                          name: "beneficiary_social_security_no",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_social_security_no"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_138, [
                                  _createElementVNode("div", _hoisted_139, [
                                    _hoisted_140,
                                    _createTextVNode(),
                                    _hoisted_141,
                                    _createVNode(_component_Field, {
                                      id: "beneficiary_tax_resident_usa0",
                                      modelValue: _ctx.bform.beneficiary_tax_resident_usa,
                                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.bform.beneficiary_tax_resident_usa) = $event)),
                                      class: "mx-2",
                                      name: "beneficiary_tax_resident_usa",
                                      type: "radio",
                                      rules: _ctx.requiredField,
                                      value: "1"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _hoisted_142,
                                    _createVNode(_component_Field, {
                                      id: "beneficiary_tax_resident_usa1",
                                      modelValue: _ctx.bform.beneficiary_tax_resident_usa,
                                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.bform.beneficiary_tax_resident_usa) = $event)),
                                      class: "ml-4 mx-2",
                                      name: "beneficiary_tax_resident_usa",
                                      type: "radio",
                                      rules: _ctx.requiredField,
                                      value: "0"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _hoisted_143,
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "beneficiary_tax_resident_usa"
                                    })
                                  ])
                                ]),
                                (_ctx.bform.beneficiary_type=='new' && _ctx.bform.beneficiary_tax_resident_usa==1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                                      _createElementVNode("div", _hoisted_145, [
                                        _hoisted_146,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.bform.beneficiary_tax_id,
                                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.bform.beneficiary_tax_id) = $event)),
                                          class: "form-control selected-field",
                                          name: "beneficiary_tax_id",
                                          type: "text",
                                          rules: _ctx.requiredField
                                        }, null, 8, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "beneficiary_tax_id"
                                        })
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.bform.is_driver_license!=1 && _ctx.bform.is_driver_license!='1')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_147, [
                                      _createElementVNode("div", _hoisted_148, [
                                        _hoisted_149,
                                        _createTextVNode(),
                                        _hoisted_150,
                                        _createVNode(_component_Field, {
                                          id: "colorPass0",
                                          modelValue: _ctx.bform.is_colour_passport,
                                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.bform.is_colour_passport) = $event)),
                                          class: "mx-2",
                                          name: "is_colour_passport",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "1"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_151,
                                        _createVNode(_component_Field, {
                                          id: "colorPass1",
                                          modelValue: _ctx.bform.is_colour_passport,
                                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.bform.is_colour_passport) = $event)),
                                          class: "ml-4 mx-2",
                                          name: "is_colour_passport",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "0"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_152,
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "is_colour_passport"
                                        })
                                      ]),
                                      (_ctx.bform.is_colour_passport==1 || _ctx.bform.is_colour_passport=='1')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_153, [
                                            (typeof _ctx.bform.colour_passport_url!='undefined' && _ctx.bform.colour_passport_url!='')
                                              ? (_openBlock(), _createBlock(_component_Field, {
                                                  key: 0,
                                                  onChange: _cache[42] || (_cache[42] = ($event: any) => (_ctx.uploadFile($event))),
                                                  modelValue: _ctx.bform.colour_passport,
                                                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.bform.colour_passport) = $event)),
                                                  class: "form-control selected-field",
                                                  name: "colour_passport",
                                                  type: "file"
                                                }, null, 8, ["modelValue"]))
                                              : _createCommentVNode("", true),
                                            (typeof _ctx.bform.colour_passport_url=='undefined' || _ctx.bform.colour_passport_url=='')
                                              ? (_openBlock(), _createBlock(_component_Field, {
                                                  key: 1,
                                                  onChange: _cache[44] || (_cache[44] = ($event: any) => (_ctx.uploadFile($event))),
                                                  modelValue: _ctx.bform.colour_passport,
                                                  "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.bform.colour_passport) = $event)),
                                                  class: "form-control selected-field",
                                                  name: "colour_passport",
                                                  type: "file",
                                                  rules: _ctx.requiredField
                                                }, null, 8, ["modelValue", "rules"]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_ErrorMessage, {
                                              style: {"color":"#d00000"},
                                              name: "colour_passport"
                                            }),
                                            (typeof _ctx.bform.colour_passport_url!='undefined' && _ctx.bform.colour_passport_url!='')
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 2,
                                                  class: "p-cursor",
                                                  onClick: _cache[46] || (_cache[46] = ($event: any) => {_ctx.openDoc(_ctx.bform.colour_passport_url);})
                                                }, [
                                                  _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_154),
                                                  _createTextVNode(" Colour Passport ")
                                                ]))
                                              : _createCommentVNode("", true),
                                            (_ctx.bform.colour_passport_pdiv==1)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                                                  _createElementVNode("div", {
                                                    class: "progress-bar bg-dark",
                                                    role: "progressbar",
                                                    style: _normalizeStyle({'width':_ctx.bform.colour_passport_pbar+'%'}),
                                                    "aria-valuenow": _ctx.bform.colour_passport_pbar,
                                                    "aria-valuemin": "0",
                                                    "aria-valuemax": "100"
                                                  }, _toDisplayString(_ctx.bform.colour_passport_pbar_p), 13, _hoisted_156)
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_Field, {
                                              rules: _ctx.requiredField,
                                              modelValue: _ctx.bform.colour_passport_path,
                                              "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.bform.colour_passport_path) = $event)),
                                              class: "form-control selected-field",
                                              name: "colour_passport_path",
                                              type: "hidden"
                                            }, null, 8, ["rules", "modelValue"]),
                                            _createVNode(_component_ErrorMessage, {
                                              style: {"color":"#d00000"},
                                              name: "colour_passport_path"
                                            })
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_157, [
                                  _createElementVNode("div", _hoisted_158, [
                                    _hoisted_159,
                                    _createTextVNode(),
                                    _hoisted_160,
                                    _createVNode(_component_Field, {
                                      id: "resiProof0",
                                      modelValue: _ctx.bform.is_residence_proof,
                                      "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.bform.is_residence_proof) = $event)),
                                      class: "mx-2",
                                      name: "is_residence_proof",
                                      type: "radio",
                                      rules: _ctx.requiredField,
                                      value: "1"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _hoisted_161,
                                    _createVNode(_component_Field, {
                                      id: "resiProof1",
                                      modelValue: _ctx.bform.is_residence_proof,
                                      "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.bform.is_residence_proof) = $event)),
                                      class: "ml-4 mx-2",
                                      name: "is_residence_proof",
                                      type: "radio",
                                      rules: _ctx.requiredField,
                                      value: "0"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _hoisted_162,
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "is_residence_proof"
                                    })
                                  ]),
                                  (_ctx.bform.is_residence_proof==1 || _ctx.bform.is_residence_proof=='1')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                                        (typeof _ctx.bform.residence_proof_url!='undefined' && _ctx.bform.residence_proof_url!='')
                                          ? (_openBlock(), _createBlock(_component_Field, {
                                              key: 0,
                                              onChange: _cache[50] || (_cache[50] = ($event: any) => (_ctx.uploadFile($event))),
                                              modelValue: _ctx.bform.residence_proof,
                                              "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.bform.residence_proof) = $event)),
                                              class: "form-control selected-field",
                                              name: "residence_proof",
                                              type: "file"
                                            }, null, 8, ["modelValue"]))
                                          : _createCommentVNode("", true),
                                        (typeof _ctx.bform.residence_proof_url=='undefined' || _ctx.bform.residence_proof_url=='')
                                          ? (_openBlock(), _createBlock(_component_Field, {
                                              key: 1,
                                              onChange: _cache[52] || (_cache[52] = ($event: any) => (_ctx.uploadFile($event))),
                                              modelValue: _ctx.bform.residence_proof,
                                              "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.bform.residence_proof) = $event)),
                                              class: "form-control selected-field",
                                              name: "residence_proof",
                                              type: "file",
                                              rules: _ctx.requiredField
                                            }, null, 8, ["modelValue", "rules"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "residence_proof"
                                        }),
                                        (typeof _ctx.bform.residence_proof_url!='undefined' && _ctx.bform.residence_proof_url!='')
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 2,
                                              class: "p-cursor",
                                              onClick: _cache[54] || (_cache[54] = ($event: any) => {_ctx.openDoc(_ctx.bform.residence_proof_url);})
                                            }, [
                                              _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_164),
                                              _createTextVNode(" Residence Proof ")
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.bform.residence_proof_pdiv==1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                                              _createElementVNode("div", {
                                                class: "progress-bar bg-dark",
                                                role: "progressbar",
                                                style: _normalizeStyle({'width':_ctx.bform.residence_proof_pbar+'%'}),
                                                "aria-valuenow": _ctx.bform.residence_proof_pbar,
                                                "aria-valuemin": "0",
                                                "aria-valuemax": "100"
                                              }, _toDisplayString(_ctx.bform.residence_proof_pbar_p), 13, _hoisted_166)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_Field, {
                                          rules: _ctx.requiredField,
                                          modelValue: _ctx.bform.residence_proof_path,
                                          "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.bform.residence_proof_path) = $event)),
                                          class: "form-control selected-field",
                                          name: "residence_proof_path",
                                          type: "hidden"
                                        }, null, 8, ["rules", "modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "residence_proof_path"
                                        })
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_167, [
                                  _createElementVNode("div", _hoisted_168, [
                                    _hoisted_169,
                                    _createTextVNode(),
                                    _hoisted_170,
                                    _createVNode(_component_Field, {
                                      id: "contract_proof0",
                                      modelValue: _ctx.bform.is_contract_proof,
                                      "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.bform.is_contract_proof) = $event)),
                                      class: "mx-2",
                                      name: "is_contract_proof",
                                      type: "radio",
                                      rules: _ctx.requiredField,
                                      value: "1"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _hoisted_171,
                                    _createVNode(_component_Field, {
                                      id: "contract_proof1",
                                      modelValue: _ctx.bform.is_contract_proof,
                                      "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.bform.is_contract_proof) = $event)),
                                      class: "ml-4 mx-2",
                                      name: "is_contract_proof",
                                      type: "radio",
                                      rules: _ctx.requiredField,
                                      value: "0"
                                    }, null, 8, ["modelValue", "rules"]),
                                    _hoisted_172,
                                    _createVNode(_component_ErrorMessage, {
                                      style: {"color":"#d00000"},
                                      name: "is_contract_proof"
                                    })
                                  ]),
                                  (_ctx.bform.is_contract_proof==1 || _ctx.bform.is_contract_proof=='1')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_173, [
                                        (typeof _ctx.bform.contract_proof_url!='undefined' && _ctx.bform.contract_proof_url!='')
                                          ? (_openBlock(), _createBlock(_component_Field, {
                                              key: 0,
                                              onChange: _cache[58] || (_cache[58] = ($event: any) => (_ctx.uploadFile($event))),
                                              modelValue: _ctx.bform.contract_proof,
                                              "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.bform.contract_proof) = $event)),
                                              class: "form-control selected-field",
                                              name: "contract_proof",
                                              type: "file"
                                            }, null, 8, ["modelValue"]))
                                          : _createCommentVNode("", true),
                                        (typeof _ctx.bform.contract_proof_url=='undefined' || _ctx.bform.contract_proof_url=='')
                                          ? (_openBlock(), _createBlock(_component_Field, {
                                              key: 1,
                                              onChange: _cache[60] || (_cache[60] = ($event: any) => (_ctx.uploadFile($event))),
                                              modelValue: _ctx.bform.contract_proof,
                                              "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.bform.contract_proof) = $event)),
                                              class: "form-control selected-field",
                                              name: "contract_proof",
                                              type: "file",
                                              rules: _ctx.requiredField
                                            }, null, 8, ["modelValue", "rules"]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "contract_proof"
                                        }),
                                        (typeof _ctx.bform.contract_proof_url!='undefined' && _ctx.bform.contract_proof_url!='')
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 2,
                                              class: "p-cursor",
                                              onClick: _cache[62] || (_cache[62] = ($event: any) => {_ctx.openDoc(_ctx.bform.contract_proof_url);})
                                            }, [
                                              _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_174),
                                              _createTextVNode(" Contract Proof ")
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.bform.contract_proof_pdiv==1)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
                                              _createElementVNode("div", {
                                                class: "progress-bar bg-dark",
                                                role: "progressbar",
                                                style: _normalizeStyle({'width':_ctx.bform.contract_proof_pbar+'%'}),
                                                "aria-valuenow": _ctx.bform.contract_proof_pbar,
                                                "aria-valuemin": "0",
                                                "aria-valuemax": "100"
                                              }, _toDisplayString(_ctx.bform.contract_proof_pbar_p), 13, _hoisted_176)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_Field, {
                                          rules: _ctx.requiredField,
                                          modelValue: _ctx.bform.contract_proof_path,
                                          "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.bform.contract_proof_path) = $event)),
                                          class: "form-control selected-field",
                                          name: "contract_proof_path",
                                          type: "hidden"
                                        }, null, 8, ["rules", "modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "contract_proof_path"
                                        })
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                (_ctx.bform.beneficiary_type=='corporate')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_177, [
                                      _createElementVNode("div", _hoisted_178, [
                                        _hoisted_179,
                                        _createTextVNode(),
                                        _hoisted_180,
                                        _createVNode(_component_Field, {
                                          id: "incorporation_certi0",
                                          modelValue: _ctx.bform.is_incorporation_certi,
                                          "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.bform.is_incorporation_certi) = $event)),
                                          class: "mx-2",
                                          name: "is_incorporation_certi",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "1"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_181,
                                        _createVNode(_component_Field, {
                                          id: "incorporation_certi1",
                                          modelValue: _ctx.bform.is_incorporation_certi,
                                          "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.bform.is_incorporation_certi) = $event)),
                                          class: "ml-4 mx-2",
                                          name: "is_incorporation_certi",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "0"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_182,
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "is_incorporation_certi"
                                        })
                                      ]),
                                      (_ctx.bform.is_incorporation_certi==1 || _ctx.bform.is_incorporation_certi=='1')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_183, [
                                            (typeof _ctx.bform.incorporation_certi_url!='undefined' && _ctx.bform.incorporation_certi_url!='')
                                              ? (_openBlock(), _createBlock(_component_Field, {
                                                  key: 0,
                                                  onChange: _cache[66] || (_cache[66] = ($event: any) => (_ctx.uploadFile($event))),
                                                  modelValue: _ctx.bform.incorporation_certi,
                                                  "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.bform.incorporation_certi) = $event)),
                                                  class: "form-control selected-field",
                                                  name: "incorporation_certi",
                                                  type: "file"
                                                }, null, 8, ["modelValue"]))
                                              : _createCommentVNode("", true),
                                            (typeof _ctx.bform.incorporation_certi_url=='undefined' || _ctx.bform.incorporation_certi_url=='')
                                              ? (_openBlock(), _createBlock(_component_Field, {
                                                  key: 1,
                                                  onChange: _cache[68] || (_cache[68] = ($event: any) => (_ctx.uploadFile($event))),
                                                  modelValue: _ctx.bform.incorporation_certi,
                                                  "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.bform.incorporation_certi) = $event)),
                                                  class: "form-control selected-field",
                                                  name: "incorporation_certi",
                                                  type: "file",
                                                  rules: _ctx.requiredField
                                                }, null, 8, ["modelValue", "rules"]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_ErrorMessage, {
                                              style: {"color":"#d00000"},
                                              name: "incorporation_certi"
                                            }),
                                            (typeof _ctx.bform.incorporation_certi_url!='undefined' && _ctx.bform.incorporation_certi_url!='')
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 2,
                                                  class: "p-cursor",
                                                  onClick: _cache[70] || (_cache[70] = ($event: any) => {_ctx.openDoc(_ctx.bform.incorporation_certi_url);})
                                                }, [
                                                  _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_184),
                                                  _createTextVNode(" Incorporation Certificate ")
                                                ]))
                                              : _createCommentVNode("", true),
                                            (_ctx.bform.incorporation_certi_pdiv==1)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                                                  _createElementVNode("div", {
                                                    class: "progress-bar bg-dark",
                                                    role: "progressbar",
                                                    style: _normalizeStyle({'width':_ctx.bform.incorporation_certi_pbar+'%'}),
                                                    "aria-valuenow": _ctx.bform.incorporation_certi_pbar,
                                                    "aria-valuemin": "0",
                                                    "aria-valuemax": "100"
                                                  }, _toDisplayString(_ctx.bform.incorporation_certi_pbar_p), 13, _hoisted_186)
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_Field, {
                                              rules: _ctx.requiredField,
                                              modelValue: _ctx.bform.incorporation_certi_path,
                                              "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.bform.incorporation_certi_path) = $event)),
                                              class: "form-control selected-field",
                                              name: "incorporation_certi_path",
                                              type: "hidden"
                                            }, null, 8, ["rules", "modelValue"]),
                                            _createVNode(_component_ErrorMessage, {
                                              style: {"color":"#d00000"},
                                              name: "incorporation_certi_path"
                                            })
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.bform.is_colour_passport!=1 && _ctx.bform.is_colour_passport!='1')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_187, [
                                      _createElementVNode("div", _hoisted_188, [
                                        _hoisted_189,
                                        _createTextVNode(),
                                        _hoisted_190,
                                        _createVNode(_component_Field, {
                                          id: "driver_license0",
                                          modelValue: _ctx.bform.is_driver_license,
                                          "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.bform.is_driver_license) = $event)),
                                          class: "mx-2",
                                          name: "is_driver_license",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "1"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_191,
                                        _createVNode(_component_Field, {
                                          id: "driver_license1",
                                          modelValue: _ctx.bform.is_driver_license,
                                          "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.bform.is_driver_license) = $event)),
                                          class: "ml-4 mx-2",
                                          name: "is_driver_license",
                                          type: "radio",
                                          rules: _ctx.requiredField,
                                          value: "0"
                                        }, null, 8, ["modelValue", "rules"]),
                                        _hoisted_192,
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "is_driver_license"
                                        })
                                      ]),
                                      (_ctx.bform.is_driver_license==1 || _ctx.bform.is_driver_license=='1')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                                            (typeof _ctx.bform.driver_license_url!='undefined' && _ctx.bform.driver_license_url!='')
                                              ? (_openBlock(), _createBlock(_component_Field, {
                                                  key: 0,
                                                  onChange: _cache[74] || (_cache[74] = ($event: any) => (_ctx.uploadFile($event))),
                                                  modelValue: _ctx.bform.driver_license,
                                                  "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.bform.driver_license) = $event)),
                                                  class: "form-control selected-field",
                                                  name: "driver_license",
                                                  type: "file"
                                                }, null, 8, ["modelValue"]))
                                              : _createCommentVNode("", true),
                                            (typeof _ctx.bform.driver_license_url=='undefined' || _ctx.bform.driver_license_url=='')
                                              ? (_openBlock(), _createBlock(_component_Field, {
                                                  key: 1,
                                                  onChange: _cache[76] || (_cache[76] = ($event: any) => (_ctx.uploadFile($event))),
                                                  modelValue: _ctx.bform.driver_license,
                                                  "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.bform.driver_license) = $event)),
                                                  class: "form-control selected-field",
                                                  name: "driver_license",
                                                  type: "file",
                                                  rules: _ctx.requiredField
                                                }, null, 8, ["modelValue", "rules"]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_ErrorMessage, {
                                              style: {"color":"#d00000"},
                                              name: "driver_license"
                                            }),
                                            (typeof _ctx.bform.driver_license_url!='undefined' && _ctx.bform.driver_license_url!='')
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 2,
                                                  class: "p-cursor",
                                                  onClick: _cache[78] || (_cache[78] = ($event: any) => {_ctx.openDoc(_ctx.bform.driver_license_url);})
                                                }, [
                                                  _createElementVNode("span", { innerHTML: _ctx.svg_image }, null, 8, _hoisted_194),
                                                  _createTextVNode(" Driver License Copy ")
                                                ]))
                                              : _createCommentVNode("", true),
                                            (_ctx.bform.driver_license_pdiv==1)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
                                                  _createElementVNode("div", {
                                                    class: "progress-bar bg-dark",
                                                    role: "progressbar",
                                                    style: _normalizeStyle({'width':_ctx.bform.driver_license_pbar+'%'}),
                                                    "aria-valuenow": _ctx.bform.driver_license_pbar,
                                                    "aria-valuemin": "0",
                                                    "aria-valuemax": "100"
                                                  }, _toDisplayString(_ctx.bform.driver_license_pbar_p), 13, _hoisted_196)
                                                ]))
                                              : _createCommentVNode("", true),
                                            _createVNode(_component_Field, {
                                              rules: _ctx.requiredField,
                                              modelValue: _ctx.bform.driver_license_path,
                                              "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event: any) => ((_ctx.bform.driver_license_path) = $event)),
                                              class: "form-control selected-field",
                                              name: "driver_license_path",
                                              type: "hidden"
                                            }, null, 8, ["rules", "modelValue"]),
                                            _createVNode(_component_ErrorMessage, {
                                              style: {"color":"#d00000"},
                                              name: "driver_license_path"
                                            })
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]),
                        _hoisted_197
                      ])
                    ]),
                    _: 1
                  }, 8, ["onSubmit"])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}